import { TooltipContext } from "@progress/kendo-react-charts";

export const ColumnChartTooltipRenderer = (
  context: TooltipContext,
  valueFormatter?: (v?: number) => string
) => {
  const format = (v?: any) => {
    switch (typeof v) {
      case "number":
        if (valueFormatter) {
          return valueFormatter(v);
        }
        return v.toLocaleString(undefined, { maximumFractionDigits: 0 });
      case "string":
        return v;
      default:
        return "";
    }
  };

  return (
    <div>
      <h6 style={{ color: "var(--tooltip-color)" }}>
        {context.point.series.name}
      </h6>
      <div>{format(context.point.value)}</div>
    </div>
  );
};
